import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { axiosClient } from '@as-react/common-utils';
import { useQuery } from '@tanstack/react-query';
import { InfoIcon } from '@yonderland/andes-icons';
import { Stack, TextAlpha, Modal, Image, Grid, Icon, useDialogContext, LinkButton, Breakpoint, BottomSheet, Box, } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { FilterWizardItem } from './FilterWizardItem';
const loadFilterWizardData = (filterWizardPath, filterOn) => __awaiter(void 0, void 0, void 0, function* () {
    const axiosConfig = {
        method: 'GET',
        url: `${filterWizardPath}.model.${filterOn}.json`,
        withCredentials: true,
    };
    try {
        const response = yield axiosClient.request(axiosConfig);
        return response.data;
    }
    catch (_a) {
        return null;
    }
});
const FilterWizardTrigger = ({ onClick }) => (_jsx(LinkButton, { size: "sm", onClick: onClick, children: _jsx(Icon, { size: "xs", source: InfoIcon }) }));
const ModalTrigger = () => {
    const { open } = useDialogContext();
    const handleClick = (event) => {
        event.stopPropagation();
        open();
    };
    return _jsx(FilterWizardTrigger, { onClick: handleClick });
};
export const FilterWizard = ({ filter, filterWizardPath }) => {
    const dispatch = useDispatch();
    const { data } = useQuery({
        queryKey: ['filterWizardData', filter.filterOn],
        queryFn: () => loadFilterWizardData(filterWizardPath, filter.filterOn),
        enabled: !!filter.filterOn && !!filterWizardPath,
    });
    useEffect(() => {
        if (data) {
            dispatch(analyticsActions.filterWizardOpened(filter.filterOn));
        }
    }, [data]);
    if (!filter.values) {
        return null;
    }
    const getContent = () => (_jsxs(Stack, { direction: "col", gap: "6", children: [_jsxs(Stack, { direction: "col", gap: "2", children: [_jsx(TextAlpha, { variant: "headingS", children: (data === null || data === void 0 ? void 0 : data.title) || filter.name }), !!(data === null || data === void 0 ? void 0 : data.description) && !!(data === null || data === void 0 ? void 0 : data.image) ? (_jsxs(Grid, { columns: { base: 1, md: 2 }, gap: "2", children: [_jsx(TextAlpha, { children: data === null || data === void 0 ? void 0 : data.description }), _jsx(Image, { source: data === null || data === void 0 ? void 0 : data.image, lazyLoad: true, alt: (data === null || data === void 0 ? void 0 : data.title) || filter.name })] })) : ((!!(data === null || data === void 0 ? void 0 : data.description) || !!(data === null || data === void 0 ? void 0 : data.image)) && (_jsxs(_Fragment, { children: [!!(data === null || data === void 0 ? void 0 : data.description) && _jsx(TextAlpha, { children: data === null || data === void 0 ? void 0 : data.description }), !!(data === null || data === void 0 ? void 0 : data.image) && _jsx(Image, { source: data === null || data === void 0 ? void 0 : data.image, lazyLoad: true, alt: (data === null || data === void 0 ? void 0 : data.title) || filter.name })] })))] }), _jsx(Stack, { direction: "col", gap: "6", children: !!data &&
                    filter.values.map((filterValue) => {
                        var _a;
                        const filterWizardValue = (_a = data.values) === null || _a === void 0 ? void 0 : _a.find((filerWizardValue) => filerWizardValue.filterKey === filterValue.filterKey);
                        return (_jsx(FilterWizardItem, { title: (filterWizardValue === null || filterWizardValue === void 0 ? void 0 : filterWizardValue.title) || filterValue.name, imageURL: filterWizardValue === null || filterWizardValue === void 0 ? void 0 : filterWizardValue.image, description: filterWizardValue === null || filterWizardValue === void 0 ? void 0 : filterWizardValue.description }, filterValue.filterKey));
                    }) })] }));
    return (_jsxs(_Fragment, { children: [_jsx(Breakpoint, { until: "lg", children: _jsx(FilterWizardBottomSheet, { children: getContent() }) }), _jsx(Breakpoint, { from: "lg", children: _jsxs(Modal, { children: [_jsx(Modal.Trigger, { children: _jsx(ModalTrigger, {}) }), _jsx(Modal.Content, { children: getContent() })] }) })] }));
};
const TEST_ID = 'filter-wizard-bottom-sheet';
const FilterWizardBottomSheet = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleClick = (event) => {
        event.stopPropagation();
        setIsOpen(true);
    };
    const handleClose = () => {
        setIsOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(FilterWizardTrigger, { onClick: handleClick }), isOpen &&
                createPortal(_jsx(BottomSheet, { isOpen: isOpen, fullHeightOnScroll: true, padding: "none", testId: TEST_ID, onClose: handleClose, children: _jsx(Box, { paddingBlockEnd: "24", children: children }) }), document.body)] }));
};
